// Client discipline-module registry. Core pages call these helpers to collect UI
// injections, already filtered to modules whose feature flag is enabled. Adding a
// module = add it to CLIENT_MODULES (+ import its components in main.ts).
import { store } from '../store';
import type { ClientModule, ModuleStudentTab, ModulePortalWidget } from './types';
import type { NavItem } from '../components/shared/sidebar';
import irishDance from './irish-dance';

export const CLIENT_MODULES: ClientModule[] = [irishDance];

const enabled = (m: ClientModule) => store.featureEnabled(m.featureFlag);

/** Student-profile tabs contributed by enabled modules (appended after the core tabs). */
export function moduleStudentTabs(): ModuleStudentTab[] {
  return CLIENT_MODULES.filter(enabled).flatMap((m) => m.studentTabs ?? []);
}

/** Portal-dashboard widgets contributed by enabled modules. */
export function modulePortalWidgets(): ModulePortalWidget[] {
  return CLIENT_MODULES.filter(enabled).flatMap((m) => m.portalWidgets ?? []);
}

/** Admin nav items contributed by enabled modules (each also self-gates via requiresFeature). */
export function moduleNavItems(): NavItem[] {
  return CLIENT_MODULES.filter(enabled).flatMap((m) => m.navItems ?? []);
}

/** Feature flags for all registered modules — used to list module toggles in Settings → Features. */
export function moduleFeatureFlags(): string[] {
  return CLIENT_MODULES.map((m) => m.featureFlag);
}
